export const getHasActiveConfirmation = (state) =>
  state.confirmation.length > 0;
export const getActiveConfirmation = (state) => state.confirmation[0];
